import { useState, useEffect } from 'react';

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navItems = [
    { id: 'hero', label: '首页' },
    { id: 'features', label: '热点爆料' },
    { id: 'cards', label: '最新爆料' },
    { id: 'carousel', label: '焦点专题' },
    { id: 'about', label: '关于平台' },
  ];

  const scrollTo = (id: string) => {
    setMenuOpen(false);
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-900/95 backdrop-blur-md shadow-lg'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 md:px-6 flex items-center justify-between h-20">
        <a
          href="#hero"
          onClick={(e) => { e.preventDefault(); scrollTo('hero'); }}
          className="flex items-center gap-2 cursor-pointer"
        >
          <span className="text-2xl font-heading font-bold text-white">
            91吃瓜
          </span>
          <span className="w-2 h-2 rounded-full bg-accent-500 mt-1"></span>
        </a>

        <nav className="hidden md:flex items-center gap-8">
          {navItems.map((item) => (
            <a
              key={item.id}
              href={`#${item.id}`}
              onClick={(e) => { e.preventDefault(); scrollTo(item.id); }}
              className="text-sm font-medium text-white/80 hover:text-accent-400 transition-colors whitespace-nowrap"
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-4">
          <button
            onClick={() => scrollTo('contact')}
            className="px-5 py-2 text-sm font-medium text-white border border-white/30 rounded-full hover:border-accent-400 hover:text-accent-400 transition-all whitespace-nowrap cursor-pointer"
          >
            我要投稿
          </button>
        </div>

        <button
          className="md:hidden w-10 h-10 flex items-center justify-center text-white cursor-pointer"
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <i className={`text-xl ${menuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
        </button>
      </div>

      {menuOpen && (
        <div className="md:hidden bg-background-900/98 backdrop-blur-md border-t border-white/10">
          <nav className="flex flex-col px-4 py-4 gap-3">
            {navItems.map((item) => (
              <a
                key={item.id}
                href={`#${item.id}`}
                onClick={(e) => { e.preventDefault(); scrollTo(item.id); }}
                className="text-sm font-medium text-white/80 hover:text-accent-400 transition-colors py-2"
              >
                {item.label}
              </a>
            ))}
            <a
              href="#contact"
              onClick={(e) => { e.preventDefault(); scrollTo('contact'); }}
              className="text-sm font-medium text-accent-400 hover:text-accent-300 transition-colors py-2"
            >
              我要投稿
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}